import { render, staticRenderFns } from "./EntityTemplateView.vue?vue&type=template&id=70776678&scoped=true"
import script from "./EntityTemplateView.vue?vue&type=script&lang=js"
export * from "./EntityTemplateView.vue?vue&type=script&lang=js"
import style0 from "./EntityTemplateView.vue?vue&type=style&index=0&id=70776678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70776678",
  null
  
)

export default component.exports